import { render, staticRenderFns } from "./VCard.vue?vue&type=template&id=54dc6b60"
import script from "./VCard.js?vue&type=script&lang=js&external"
export * from "./VCard.js?vue&type=script&lang=js&external"
import style0 from "./VCard.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import VLoader from '@/agilis/wrappers/VLoader/VLoader.vue'
installComponents(component, {VCard,VLoader})
